import { styled } from '@mui/system';

const InfoBar = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: theme.spacing(27),
  paddingTop: '55px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    paddingTop: 0,
    flexGrow: 2
  }
}));

export const InfoBarWithLogo = styled(InfoBar)({
  paddingTop: 0
});

export default InfoBar;
